import { render } from "./SafetyOccurrenceFormView.vue?vue&type=template&id=dbc59d84&scoped=true&ts=true"
import script from "./SafetyOccurrenceFormView.vue?vue&type=script&lang=ts"
export * from "./SafetyOccurrenceFormView.vue?vue&type=script&lang=ts"

import "./SafetyOccurrenceFormView.vue?vue&type=style&index=0&id=dbc59d84&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc59d84"]])

export default __exports__